module.exports = __webpack_public_path__ + "img/daren_11.9d729613.png";